import { useMemo } from 'react';
import { useCurrentCompany } from 'src/hooks/api/companies';
import { ClientType, DEFAULT_CLIENT_TYPE } from '../types/client-type.type';

/**
 * Hook to get the client type of the current company.
 * @returns The client type (GENERAL or REAL_ESTATE)
 */
export const useClientType = (): ClientType => {
  const { currentCompany, loading } = useCurrentCompany();

  return useMemo<ClientType>(() => {
    if (loading) {
      return DEFAULT_CLIENT_TYPE;
    }

    return currentCompany?.clientType ?? DEFAULT_CLIENT_TYPE;
  }, [currentCompany, loading]);
};
